export default{
    cadastra:{
        method:'post',
        url:'acidentetrabalhor/cadastro'
    },
    delete:{
        method:'delete',
        url:'acidentetrabalhor/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'acidentetrabalhor/lista'
    },
    editar:{
        method:'get',
        url:'acidentetrabalhor/editar{/id}'
    },
    update:{
        method:'post',
        url:'acidentetrabalhor/update'
    },
    evento:{
        method:'get',
        url:'acidentetrabalhor/evento/2210{/id}'
    },
    eventolista:{
        method:'get',
        url:'acidentetrabalhor/evento/2210/lista{/id}'
    },
    eventocadastra:{
        method:'post',
        url:'acidentetrabalhor/evento2210/cadastro'
    },
    eventoupdate:{
        method:'post',
        url:'acidentetrabalhor/evento2210/update'
    },
    eventodelete:{
        method:'delete',
        url:'acidentetrabalhor/evento2210/deletar{/id}'
    },
}